export default function isAuthorized(userRoles, allowedRoles) {
  return allowedRoles.some(allowedRole => userRoles.includes(allowedRole))
}
